var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlobBottom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 190,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.918 13.932C133.243-3.706 176.422-2.932 218 7.02V190H3.931a103.603 103.603 0 0 1-2.164-9.455C-9.644 118.909 35.669 42.405 95.918 13.932Z",
    fill: "#FA7B6A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlobBottom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blob-bottom.7d6ebbfc67c50d79cbb7d3a298171ef3.svg";